import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useConfirmation } from '../shared/ZCard';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

// ==================== COLLECTION FORM ====================
export function CollectionForm({ open, onClose, onSave, collection }) {
  const feedback = useConfirmation();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (collection) { setTitle(collection.title || ''); setDescription(collection.description || ''); }
    else { setTitle(''); setDescription(''); }
  }, [collection, open]);

  const save = async () => {
    if (!title.trim()) return;
    try {
      if (collection) {
        await api.put(`/framed/curated/${collection.id}`, { title, description });
      } else {
        await api.post('/framed/curated', { title, description });
      }
      onSave(); onClose();
      feedback.confirm();
    } catch { feedback.fail(); }
  };

  return (
    <Dialog open={open} onOpenChange={v => !v && onClose()}>
      <DialogContent className="bg-white/[0.02] border-white/[0.06] text-[#f0f0f5] max-w-md" aria-describedby="coll-form-desc">
        <DialogHeader><DialogTitle style={{ fontFamily: "'Playfair Display', serif" }}>{collection ? 'Edit Collection' : 'New Collection'}</DialogTitle></DialogHeader>
        <p id="coll-form-desc" className="sr-only">Create or edit collection</p>
        <div className="space-y-4 mt-2">
          <Input value={title} onChange={e => setTitle(e.target.value)} placeholder="Collection name"
            className="bg-[#0a0a0f] border-white/[0.06] text-[#f0f0f5] placeholder:text-[#6b7084]"
            style={{ fontFamily: "'Playfair Display', serif" }} data-testid="coll-title-input" />
          <Textarea value={description} onChange={e => setDescription(e.target.value)} placeholder="Description"
            className="bg-[#0a0a0f] border-white/[0.06] text-[#f0f0f5] placeholder:text-[#6b7084] min-h-[60px]"
            style={{ fontFamily: "'Cormorant Garamond', serif" }} data-testid="coll-desc-input" />
          <Button onClick={save} disabled={!title.trim()} className="w-full bg-[#6B35B8] hover:bg-[#6B35B8]/90 text-white rounded-full" data-testid="coll-save-btn">
            {collection ? 'Update' : 'Create'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
